import {useEffect, useState, useContext} from 'react';
import getCookie from '../../../partials/cookie';
import { Errors } from '../../../partials/Partials';
import { UserContext } from '../../../partials/Context';
import ConfirmButtons from './ConfirmButtons';
import VerifyNumber from './VerifyNumber';


function Potwierdzenie(props) {

    let rhash = window.location.pathname.split('/')[3]
    let csrftoken = getCookie('csrftoken');
    const user = useContext(UserContext);
    const {is_authenticated, is_staff} = user || '';
    const [consultations_data, setConsultationsData] = useState({});
    const [confirmed, setConfirmed] = useState(false);
    const [errors, setErrors] = useState([]);

    useEffect(()=>{
        fetch(`/api/phone_consultations/${rhash}`).then(res => {
            if (res.ok) {
                res.json().then(
                    data => {
                        setConsultationsData(data)
                    }
                )
            } else {
                setErrors(['Nie udało się pobrać danych'])
        }
        })
    },[rhash])


    const correctData = () => {
        window.location.replace(`/bezplatna-konsultacja-telefoniczna/formularz-zgloszenia/${rhash}`);
    }

    const confirmData = (e) => {    
        e.preventDefault();
        fetch(`/ajax/konsultacja-telefoniczna/potwierdzenie/${rhash}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken,
            }
        }).then(res => {
            if(!res.ok) {
                res.json().then(
                    data=> setErrors([data.msg])
                )
            } else {
                setConfirmed(true);
            }
        })
    }
    const {title, city, category, phone, email} = consultations_data || '';
    const {name: city_name} = city || '';
    const {name: category_name} = category || '';

    return(
        <div className="confirm" style={is_authenticated?{paddingTop: '40px'}:{}}>
            <Errors errors={errors}/>
            <legend>Potwierdzenie danych:</legend>
            <hr/>
            <div className="data-to-confirm">
                <div className="data-item">
                    <span className="title">Temat rozmowy:</span>
                    <span className="data">{title}</span>
                </div>
                <div className="data-item">
                    <span className="title">Miejscowość:</span>
                    <span className="data">{city_name}</span>
                </div>
                <div className="data-item">
                    <span className="title">Kategoria:</span>
                    <span className="data">{category_name}</span>
                </div>
                <div className="data-item">
                    <span className="title">Numer telefonu:</span>
                    <span className="data">{phone}</span>
                </div>
                <div className="data-item">
                    <span className="title">Adres email:</span>
                    <span className="data">{email}</span>
                </div>
                <div className="data-item">
                    <span className="title">Nazwa usługi:</span>
                    <span className="data">Konsultacja telefoniczna</span>
                </div>
            </div>
            <hr/>
            <ConfirmButtons staff={is_staff} correctData={correctData} confirmData={confirmData} confirmed={confirmed}/>
            <VerifyNumber staff={is_staff} setErrors={setErrors} errors={errors}confirmed={confirmed} rhash={rhash}/>
        </div>
    )
}






export default Potwierdzenie;